import SuggestFieldBase from '../base/SuggestField';
import createField from './createField';

const SuggestField = createField(SuggestFieldBase);

export default SuggestField;
